import { Component, OnInit } from '@angular/core';
import { IndexloginService } from '../indexlogin/indexlogin.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.css']
})
export class NotfoundComponent implements OnInit {

  constructor(private authService : IndexloginService, private router: Router) { 
     const isLoggedIn = this.authService.isLoggedIn();

  if (!isLoggedIn) {
    // Extract subdomain from URL or use default
    const subdomain = localStorage.getItem('sub_domain') || 'waldoerp'; // default to 'waldoerp' if no subdomain
    this.router.navigate([`${subdomain}/login`]);
  }
  }

  ngOnInit(): void {

    
  }

}
